import { ChevronLeft, ChevronRight } from "react-bootstrap-icons";
import { useArsListing } from "./ArsListingContextProvider";
import { ARSL_SET_VIEW_COLUMN_PROPERTIES_ID } from "./interface";

export interface ArsListingColumnNavButtonsProps {
  colIx: number;
}

/**
 * Chevron buttons to navigate between columns in the ARS listing.
 *
 * @param props - The props for the component.
 * @param props.colIx - The index of the column to navigate from
 * @returns A JSX element representing the navigation buttons
 */
export const ArsListingColumnNavButtons = ({
  colIx,
}: ArsListingColumnNavButtonsProps): React.ReactNode => {
  const { state, dispatch } = useArsListing();
  if (!state || !state.settings.viewColumnPropertiesId) return null;

  const totalColumns = state.bodyData.arsListingColumns.length;
  const leftDest = colIx > 0 ? state.bodyData.arsListingColumns[colIx - 1].id : null;
  const rightDest =
    colIx < totalColumns - 1 ? state.bodyData.arsListingColumns[colIx + 1].id : null;

  /**
   * Change properties view column with a dispatch action
   *
   * @param id - New column id
   */
  const setNewviewColumnPropertiesId = (id: string) => {
    dispatch({
      operation: ARSL_SET_VIEW_COLUMN_PROPERTIES_ID,
      colId: id,
    });
  };

  return (
    <div className="d-flex align-items-center">
      <ChevronLeft
        style={
          leftDest
            ? { cursor: "pointer", color: "black" }
            : { cursor: "not-allowed", color: "grey" }
        }
        aria-label="Previous column"
        title={"Previous column"}
        onClick={() => leftDest && setNewviewColumnPropertiesId(leftDest)}
      />
      <ChevronRight
        style={
          rightDest
            ? { cursor: "pointer", color: "black" }
            : { cursor: "not-allowed", color: "grey" }
        }
        aria-label="Next column"
        title={"Next column"}
        onClick={() => rightDest && setNewviewColumnPropertiesId(rightDest)}
      />
    </div>
  );
};

ArsListingColumnNavButtons.displayName = "ArsListingColumnNavButtons";
